<template>
    <div class="panel-body">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>
        <div class="scroller padded">
            <h2 class="panel-header"><img src="../assets/nav-stats.png" />Statistiche {{ (city) ? city.name : (state) ? state.name : country.value }}</h2>

            <loading-progress
                    :indeterminate="loading"
                    :hideBackground="true"
                    shape="line"
                    :size="loaderSize"
                    :width="loaderSize"
                    height="3"
            />

            <apexchart v-if="series[0].data.length>0" type=area height=300 :options="chartOptions" :series="series" />

            <div class="placeholder-text" v-if="!stations.open && series[0].data.length==0 && !loading">Non ci sono dati</div>

            <h3 v-if="stations.open">Prezzo<span class="price-title">{{ avgprice }}</span></h3>

            <ul class="list" v-if="stations.open">
                <li class="row-even">
                    <p class="description">Aperti</p>
                    <p class="number">{{ stations.open }}</p>
                </li>
                <li class="row-odd">
                    <p class="description">Fuori Servizio</p>
                    <p class="number">{{ stations.closed }}</p>
                </li>
                <li class="row-even">
                    <p class="description">Totale Impianti</p>
                    <p class="number">{{ stations.open + stations.closed }}</p>
                </li>
            </ul>

            <div class="copyright">
                <img src="https://www.ecomotori.net/wp-content/themes/ecomotori/img/powered_by_orizzontale.png"/>
            </div>
        </div>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import VueApexCharts from 'vue-apexcharts'
    import Api from "../api";

    export default {
        components: {
            apexchart: VueApexCharts,
        },
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            loadData(_position) {
                //FIXME: prendo i parametri dal parent
                this.fuel = this.$parent.$parent.$parent.$parent.fuel;

                if(_position) {
                    this.country = _position.country;
                    this.state = _position.state;
                    this.city = _position.city;
                } else {
                    this.country = this.$parent.$parent.$parent.$parent.country;
                    this.state = this.$parent.$parent.$parent.$parent.state;
                    this.city = this.$parent.$parent.$parent.$parent.city;
                }

                var $scope = this;

                if(this.country && this.fuel) {

                    $scope.loading = true;

                    Api.getAnalytics(this.country.idstato,(this.state) ? this.state.id : null, (this.city) ? this.city.id : null,this.fuel,function(err,res){

                        $scope.avgprice = res.avgprice;
                        $scope.stations = res.stations;
                        $scope.currency = res.currency;

                        $scope.chartOptions.yaxis.labels.formatter = function formatter(val) {
                            return (val/1000).toFixed(3).replace('.',',') + $scope.currency
                        };
                        $scope.chartOptions.tooltip.y.formatter = function formatter(val) {
                            return (val/1000).toFixed(3).replace('.',',') + $scope.currency
                        };

                        $scope.series[0].data = [];

                        if(res.prices) {
                            for (var i = 0; i < res.prices.length; i++) {

                                var ts = res.prices[i][0] * 1000;
                                var value = parseInt(res.prices[i][1] * 1000);

                                if (i == 0 || $scope.yaxis.min > value) $scope.yaxis.min = value
                                if (i == 0 || $scope.yaxis.max < value) $scope.yaxis.max = value

                                $scope.series[0].data.push([ts, value]);
                            }
                        }

                        $scope.loading = false;

                    });
                }
            }
        },
        data() {
            return {
                loading: false,
                country: false,
                state: false,
                city: false,
                stations: {},
                currency: null,
                avgprice: null,
                series: [{
                    name: 'Prices',
                    data: []
                }],
                yaxis: {
                    labels: {
                        formatter: null,
                    },
                },
                chartOptions: {
                    chart: {
                        stacked: false,
                        zoom: {
                            type: 'x',
                            enabled: true
                        },
                        toolbar: {
                            autoSelected: 'zoom',
                            tools: {
                                download: false,
                                zoomin: false,
                                zoomout: false
                            }
                        }
                    },
                    stroke: {
                        show: true,
                        curve: 'straight',
                        lineCap: 'butt',
                        width: 2
                    },
                    fill: {
                        type: 'solid',
                        opacity: 0
                    },
                    dataLabels: {
                        enabled: false
                    },
                    markers: {
                        size: 0,
                        style: 'full',
                    },
                    colors: ['#0c71b2'],
                    xaxis: {
                        type: 'datetime',
                    },
                    yaxis: {
                        labels: {
                            formatter: null,
                        },
                    },
                    tooltip: {
                        shared: false,
                        y: {
                            formatter: null,
                        }
                    }
                },
                loaderSize: 420
            };
        },
        created() {
            serverBus.$on('areaChanged',this.loadData);
            serverBus.$emit('pageChanged',{page:'MapStats'});

            if(window.innerWidth < 480) {
                this.loaderSize = window.innerWidth - 60;
            }

            this.loadData(false);
        },
        formatter(val) {
            return (val/1000).toFixed(3).replace('.',',')
        }
    }

</script>
<style lang="scss">
    #ecomotoriMap {
      h3 {
          padding: 0px 10px;
          .price-title {
              float: right;
          }
      }
      .apexcharts-canvas {
          border: 1px solid #999999;
          margin-top: 20px;
      }
      .copyright {
          text-align: right;
          margin-top: 20px;
          img {
              width: 140px;
          }
      }
    }
</style>
